module.exports = __webpack_public_path__ + "img/freeuser.fb22f620.svg";